var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfAttach = function SvgPdfAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pdf-attach_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.222 0H1.778C.79 0 0 .791 0 1.778v12.444A1.778 1.778 0 0 0 1.778 16h12.444A1.778 1.778 0 0 0 16 14.222V1.778A1.778 1.778 0 0 0 14.222 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0ZM5.778 7.556c0 .71-.622 1.333-1.334 1.333h-.888v1.778H2.222V5.333h2.222c.712 0 1.334.623 1.334 1.334v.889Zm4.444 1.777c0 .711-.622 1.334-1.333 1.334H6.667V5.333h2.222c.711 0 1.333.623 1.333 1.334v2.666Zm3.556-2.666h-1.334v.889h1.334v1.333h-1.334v1.778h-1.333V5.333h2.667v1.334ZM8 6.667h.889v2.666H8V6.667Zm-4.444 0h.888v.889h-.888v-.89Z",
    fill: "#AD0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf-attach_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgPdfAttach;